import _ from 'lodash';
import { getAppModuleConfig } from '../../../selectors/configSelectors';
import { MuleRedDotFeatureList } from '../types/muleCustStateType';

const MODULE_NAME = 'emma-home-revamp';

export const getMuleCustStateChannel = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `muleCustState.channel`, '');
};

export const getMuleRedDotCustKey = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `muleCustState.redDotCustKey`, '');
};

export const getMuleCustStateSetUrl = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `muleCustState.setApi`, '');
};

export const getMuleCustStateGetUrl = (state: any) => {
  const config = getAppModuleConfig<any>(state, MODULE_NAME);
  return _.get(config, `muleCustState.getApi`, '');
};

export const getMuleRedDotState = (state: any): MuleRedDotFeatureList => {
  return _.get(state, `hk-emma-web-module-home/muleCustState.redDot`, null);
};

export const getMuleRedDotError = (state: any): any => {
  return _.get(state, `hk-emma-web-module-home/muleCustState.error`, null);
};
